// Lucian UX/UI Prompt #163 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#163
// 自分の率（棒）とチーム平均（白い目印）、お手本の人（緑の目印）を1本に重ねる。差が長さで見える。
import React from 'react';
import { bulletScale } from '../../utils/home-viz.mjs';
import './lucian.css';

const pct = (r) => `${(r * 100).toFixed(1)}%`;

export default function BulletCompare({ label, self, team, leader = null, leaderName = null }) {
  const max = bulletScale([self, team, leader || 0]);
  const pos = (v) => `${Math.min(100, (v / max) * 100).toFixed(2)}%`;
  // 目印の文字は真ん中寄せ。左右の端に近いときは内側へ寄せて、カードからはみ出さないようにする。
  const tx = (v) => { const p = (v / max) * 100; return p > 80 ? '-100%' : p < 20 ? '0%' : '-50%'; };
  const gap = team - self;
  const ticks = [0, max / 2, max];
  return (
    <div role="group" aria-label={`${label}：自分 ${pct(self)}、チーム平均 ${pct(team)}${leader != null ? `、${leaderName || 'お手本'} ${pct(leader)}` : ''}`}>
      <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--ux-ink)' }}>{label}</div>
      <div className="lx-bullet__head">
        <span className="lx-bullet__value">{pct(self)}</span>
        <span style={{ fontSize: 14, color: 'var(--ux-ink-3)' }}>あなた</span>
        {gap > 0 && <span style={{ fontSize: 14, fontWeight: 750, color: 'var(--loss)' }}>チームより -{(gap * 100).toFixed(1)}pt</span>}
      </div>
      <div className="lx-bullet__track" aria-hidden="true">
        <div className="lx-bullet__actual" style={{ width: pos(self) }} />
        <div className="lx-bullet__mark is-team" style={{ left: pos(team), '--tx': tx(team) }} data-label={`チーム ${pct(team)}`} />
        {leader != null && <div className="lx-bullet__mark is-leader" style={{ left: pos(leader), '--tx': tx(leader) }} data-label={`${leaderName || 'お手本'} ${pct(leader)}`} />}
      </div>
      <div className="lx-bullet__ticks" aria-hidden="true">{ticks.map((t, i) => <span key={i}>{Math.round(t * 100)}%</span>)}</div>
    </div>
  );
}
